import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
  layout: React.ComponentType<any>;
  menuTitle?: string;
  whiteBgColor?: boolean;
  isFooter?: boolean;
  showBackArrow?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  layout: Layout,
  menuTitle,
  whiteBgColor,
  isFooter,
  showBackArrow,
  ...rest
}) => {
  const isAuthenticated = !!localStorage.getItem('accessToken'); // 토큰 존재 여부 확인

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Layout
            menuTitle={menuTitle}
            whiteBgColor={whiteBgColor}
            isFooter={isFooter}
            showBackArrow={showBackArrow}
          >
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect to="/404" /> // 토큰이 없으면 404 페이지로 리다이렉트
        )
      }
    />
  );
};

export default PrivateRoute;
